//Other Libs
import styled from "styled-components";

export const Styles = styled.div`
  table {
    .ant-table-column-sorters {
      justify-content: center !important;
    }
  }
`;